import { gql, useMutation } from "@apollo/client";
import React, { useContext, useState } from "react";
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../context/global-context-provider";
import { differenceInMilliseconds, subMilliseconds } from "date-fns";

const SyncQuote = () => {
  const [lastSyncData, setLastSyncData] = useState(null);
  const { quoteInput, quoteStatus } = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const [getTravelQuote] = useMutation(GET_TRAVEL_QUOTE);

  const calculateDeparture = (data) => {
    const departureDate = new Date(data.departureTravel.departureDate);
    const arrivalDate = new Date(data.departureTravel.arrivalDate);
    const difference = differenceInMilliseconds(arrivalDate, departureDate);
    const newDepartureDate = subMilliseconds(departureDate, difference);

    data.departureTravel.arrivalDate = data.departureTravel.departureDate;
    data.departureTravel.departureDate = newDepartureDate.toISOString();
  };

  const calculateReturnDeparture = (data) => {
    const departureDate = new Date(data.returnTravel.departureDate);
    const arrivalDate = new Date(data.returnTravel.arrivalDate);
    const difference = differenceInMilliseconds(arrivalDate, departureDate);
    const newDepartureDate = subMilliseconds(departureDate, difference);

    data.returnTravel.arrivalDate = data.returnTravel.departureDate;
    data.returnTravel.departureDate = newDepartureDate.toISOString();
  };

  React.useEffect(() => {
    const isValidQuote =
      quoteInput?.from &&
      quoteInput?.to &&
      quoteInput?.departureDate &&
      quoteInput?.numPassengers;

    const syncData = JSON.stringify(quoteInput);

    if (isValidQuote && !quoteStatus.inProgress && syncData !== lastSyncData) {
      setLastSyncData(syncData);

      dispatch({
        type: "UPDATE_QUOTE_STATUS",
        value: { inProgress: true },
      });

      const {
        calculateDepartureMode,
        calculateReturnDepartureMode,
        ...cleanQuoteInput
      } = quoteInput;
      getTravelQuote({
        variables: {
          input: cleanQuoteInput,
        },
      })
        .then(({ data }) => {
          if (calculateDepartureMode) {
            calculateDeparture(data.getTravelQuote);
          }
          if (calculateReturnDepartureMode) {
            calculateReturnDeparture(data.getTravelQuote);
          }
          dispatch({ type: "UPDATE_QUOTE", value: data.getTravelQuote });
          dispatch({
            type: "UPDATE_QUOTE_STATUS",
            value: { inProgress: false, error: false },
          });
        })
        .catch(() => {
          dispatch({ type: "UPDATE_QUOTE", value: {} });
          dispatch({
            type: "UPDATE_QUOTE_STATUS",
            value: { inProgress: false, error: true },
          });
        });
    }
  }, [quoteInput, quoteStatus.inProgress]);

  return null;
};

export default SyncQuote;

const GET_TRAVEL_QUOTE = gql`
  fragment TravelQuote on TravelActivity {
    departureDate
    arrivalDate
    tollCost
    tollCostIncVAT
    tollCostExcVAT
    duration
    distance
    busPrices {
      bus {
        id
      }
      priceIncVat
      priceExclVat
    }
  }
  mutation GetTravelQuote($input: GetTravelQuoteInput!) {
    getTravelQuote(input: $input) {
      departureTravel {
        ...TravelQuote
      }
      returnTravel {
        ...TravelQuote
      }
    }
  }
`;
